import React from 'react';
import { Checkbox } from '@blueprintjs/core';
import moment from 'moment';
import { Link } from 'react-router';
import TextTruncate from 'react-text-truncate';

export default class RowItemListBriefJob extends React.Component {

  handleClickDetail() {
    this.props.onClickDetail(this.props.item, true);
  }
  render() {
    let tenloaidon = this.props.parent.state.DataLoaiDonThu.map((item, i) => {
      if(this.props.item.loaiDon == item.giaTri){
        return(
          <li value={item.giaTri} key={i}>{item.ten}</li>
        )
      }
    });
    return (
      <tr className={this.props.item.checked ? "active_checkbox" : ''}>
        <td className='middle-content'>
          <Checkbox checked={this.props.item.checked} className="pt-large" onChange={this.props.parent.handleChangeCheckbox.bind(this.props.parent, this.props.item)} name="checkboxDanhSachDon"/>
        </td>
        <td>{this.props.count}</td>
        <td>
          {moment(this.props.item.ngayLapDonGapLanhDaoTmp).format('DD/MM/YYYY')}<br/>
          {moment(this.props.item.ngayLapDonGapLanhDaoTmp).format('HH:mm')}
        </td>
        <td>
          {this.props.item.listNguoiDungDon.length ? (
              <ul className="list-items-table">
                <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
                <li>{this.props.item.listNguoiDungDon[0].diaChi}</li>
                <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
               </ul>
          ) : null}
        </td>
        <td>
          <Link className="txt-underline" onClick={this.handleClickDetail.bind(this)} >
            <TextTruncate
              line={3}
              truncateText="…"
              text={this.props.item.noiDung}
            />
          </Link>
        </td>
        <td>
          <ul className="list-items-table">
            {tenloaidon}
            <li>{this.props.item.soNguoi}&nbsp;Người</li>
          </ul>
        </td>
        <td>{this.props.item.coQuanDaGiaiQuyetDon ? this.props.item.coQuanDaGiaiQuyetDon.ten : ''}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/add/RowItemListBriefJob.jsx